import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { colors, ApMenu } from '@alixpartners/ui-components';

export const StyledMenu = styled(ApMenu)`
	padding-bottom: 0 !important;
	overflow: hidden !important;
	display: flex;
	flex-direction: column;
	min-width: 360px !important;
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	max-height: 100%;
`;

export const DropdownLabel = styled.button`
	max-width: 320px;
	height: 38px;
	border: none;
	font-weight: 500;
	font-size: 13px;
	letter-spacing: 0.3px;
	text-transform: uppercase;
	color: ${colors.grey8};
	border: 1px solid transparent;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 4px 0 4px 9px;
	background-color: ${colors.white};
	outline: none;

	&:hover {
		background-color: ${rgba(colors.green2, 0.1)};
	}

	&:focus {
		background-color: ${rgba(colors.green2, 0.2)};
	}

	&:active {
		background-color: ${rgba(colors.green2, 0.3)};
		border: 1px solid ${colors.green3};
	}

	${({ isOpen }) =>
		isOpen
			? css`
					border: 1px solid ${colors.green3};

					svg:last-child {
						transform: rotate(180deg);
					}
			  `
			: ''};

	${({ disabled }) =>
		disabled
			? css`
					pointer-events: none;
					background-color: none;
					color: ${colors.grey5};
			  `
			: css`
					cursor: pointer;
			  `};
`;

export const LabelText = styled.span`
	color: ${({ disabled }) =>
		disabled ? `${colors.grey5}` : `${colors.grey8}`};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 13px;
	letter-spacing: 0.3px;
	line-height: 38px;
	padding: 2px 0 0 4px;
`;

export const LabelHelper = styled.span`
	padding-top: 2px;
	line-height: 38px;
`;

export const Content = styled.div`
	height: 332px;
`;

export const Footer = styled.div`
	display: flex;
	align-items: center;
	border-top: 1px solid ${colors.grey3};
	min-height: 48px;
	padding: 0 8px;
`;

export const NoData = styled.div`
	color: ${colors.grey7};
	font-size: 16px;
	letter-spacing: 0.3px;
	text-align: center;
	padding: 16px;
`;
